module.exports = __webpack_public_path__ + "static/img/biankuang02.6971c0f.png";


//////////////////
// WEBPACK FOOTER
// ./static/biankuang02.png
// module id = XeF0
// module chunks = 1